__turbopack_context__.v({
  "field": "ProfileTabsSkeleton-module__m5GkwG__field",
  "fieldInput": "ProfileTabsSkeleton-module__m5GkwG__fieldInput",
  "fieldLabel": "ProfileTabsSkeleton-module__m5GkwG__fieldLabel",
  "fields": "ProfileTabsSkeleton-module__m5GkwG__fields",
  "headerIcon": "ProfileTabsSkeleton-module__m5GkwG__headerIcon",
  "headerSkeleton": "ProfileTabsSkeleton-module__m5GkwG__headerSkeleton",
  "headerTitle": "ProfileTabsSkeleton-module__m5GkwG__headerTitle",
  "headerTitleShort": "ProfileTabsSkeleton-module__m5GkwG__headerTitleShort",
  "headerTitles": "ProfileTabsSkeleton-module__m5GkwG__headerTitles",
  "mainSkeleton": "ProfileTabsSkeleton-module__m5GkwG__mainSkeleton",
  "navIcon": "ProfileTabsSkeleton-module__m5GkwG__navIcon",
  "navItem": "ProfileTabsSkeleton-module__m5GkwG__navItem",
  "navItemCollapsed": "ProfileTabsSkeleton-module__m5GkwG__navItemCollapsed",
  "navLabel": "ProfileTabsSkeleton-module__m5GkwG__navLabel",
  "navSkeleton": "ProfileTabsSkeleton-module__m5GkwG__navSkeleton",
  "pluginBox": "ProfileTabsSkeleton-module__m5GkwG__pluginBox",
  "pluginBoxCollapsed": "ProfileTabsSkeleton-module__m5GkwG__pluginBoxCollapsed" + " " + "ProfileTabsSkeleton-module__m5GkwG__pluginBox",
  "pluginBoxHeader": "ProfileTabsSkeleton-module__m5GkwG__pluginBoxHeader",
  "pluginBoxList": "ProfileTabsSkeleton-module__m5GkwG__pluginBoxList",
  "pluginBoxTitle": "ProfileTabsSkeleton-module__m5GkwG__pluginBoxTitle",
  "subTab": "ProfileTabsSkeleton-module__m5GkwG__subTab",
  "subTabs": "ProfileTabsSkeleton-module__m5GkwG__subTabs",
});
